const RETIREMENT_CALCULATOR = {
    // Search
    GET_RETIREMENT: "/frontend/projected-balance/filter"
};

export default RETIREMENT_CALCULATOR;